import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { Resource } from '../../../graphql/resources.datatypes';

interface DeleteResourceVars {
    id: number;
}

interface DeleteResourceData {
  deleteResource: Resource
}

export const DELETE_RESOURCE_MUTATION = gql`
    mutation deleteResource($id: Int!) {
        deleteResource(id: $id) {
          id
        }
    }
`;

export const deleteResource = () => useMutation<DeleteResourceData, DeleteResourceVars>(
  DELETE_RESOURCE_MUTATION,
    {
        update: updateCacheByType('Resource'),
    }
);

export default deleteResource;